import { AddressFrm } from './address_frm';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, AlertController, Searchbar } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';

import {
  AngularFirestore,
  AngularFirestoreCollection
} from 'angularfire2/firestore';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/switchMap';

import { Address } from '../../models/address';

@Component({
  selector: 'page-addressbrw',
  templateUrl: 'address_brw.html'
})
export class AddressBrw {

  @ViewChild('mainSearchbar') searchBar: Searchbar;
  action: number = 0
  addressCollectionRef: AngularFirestoreCollection<Address>
  address$: Observable<Address[]>
  startAt$ = new Subject<string>()
  searchString: string

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, private afs: AngularFirestore, public authData: AuthProvider) {   // added AngularFirestore (let op private!!) en alertCtrl

    this.searchString = navParams.get('searchString');
    this.action = navParams.get('action');
    
    this.address$ = this.startAt$
    .switchMap(startAt => this.afs.collection<Address>('addresses', ref => ref
    .limit(300)
    .where('uid','==',this.authData.authState.uid)
    .orderBy('code').startAt(startAt.toUpperCase()).endAt(startAt.toUpperCase() + 'Z')).snapshotChanges().map(addresses => {
        return addresses.map(address => {
        const data = address.payload.doc.data() as Address
        const id = address.payload.doc.id
        return {id, ...data}
      })
    }))

  }

  ngAfterViewInit(){
    if ((this.searchString == undefined) || (this.searchString == '')){
      this.startAt$.next('ZZZZZZZZZZ')
     } else {
       this.startAt$.next(this.searchString)
     }    
  }

  ionViewDidEnter() {
    setTimeout(() => {
      this.searchBar.setFocus();
    }, 150);
  }

  startsWith(e: any){
    let valueString = e.target.value + '';
    ((valueString == undefined) || (valueString == '')) ? this.startAt$.next('ZZZZZZZZZZ') : this.startAt$.next(valueString)
  }

  insert(){
    var callbackPromise = new Promise((resolve, reject) => {
      this.navCtrl.push(AddressFrm, {action: 1, resolve: resolve});
    }).then(data => {
      let dataString = data + ''
      this.searchString = dataString
      this.startAt$.next(dataString)
    })
  }  

  changeOrSelect(addressSelected){
    if (this.action == 4) {
      this.navCtrl.pop().then(() => this.navParams.get('resolve')(addressSelected.name))      
    } else {
      this.change(addressSelected)
    }
  }

  change(addressSelected) {
    var callbackPromise = new Promise((resolve, reject) => {
      this.navCtrl.push(AddressFrm, {action: 2, key: addressSelected.id, resolve: resolve});
    }).then(data => {
      let dataString = data + ''
      this.searchString = dataString
      this.startAt$.next(dataString)
    })
  }

  delete(addressSelected){
    this.navCtrl.push(AddressFrm, {
      action: 3,
      key: addressSelected.id
    })
  }

  generate(){
  this.addressCollectionRef = this.afs.collection<Address>('addresses')
  let genName: string = 'TEST'
    for (let i = 0; i < 100; i++){
      genName = String.fromCharCode(Math.floor(Math.random() * (90 - 65 + 1) ) + 65)
      genName = genName + String.fromCharCode(Math.floor(Math.random() * (90 - 65 + 1) ) + 65)
      genName = genName + String.fromCharCode(Math.floor(Math.random() * (90 - 65 + 1) ) + 65)
      genName = genName + String.fromCharCode(Math.floor(Math.random() * (90 - 65 + 1) ) + 65)
      // console.log(genName)
      this.addressCollectionRef.add({name:genName})      
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/address/address_brw.ts